import { Nullable } from './utilities';

export enum ErrorCode {
  PRIMER_TEARDOWN = 'PRIMER_TEARDOWN',
  PRIMER_SERVER_ERROR = 'PRIMER_SERVER_ERROR',
  THREE_DS_SETUP_ERROR = 'THREE_DS_SETUP_ERROR',
  THREE_DS_AUTH_FAILED = 'THREE_DS_AUTH_FAILED',
  THREE_DS_NEGOTIATION_ERROR = 'THREE_DS_NEGOTIATION_ERROR',
  TOKENIZATION_ERROR = 'TOKENIZATION_ERROR',
  DUPLICATE_PAYMENT_METHOD_ERROR = 'DUPLICATE_PAYMENT_METHOD_ERROR',
  CARD_NUMBER_ERROR = 'CARD_NUMBER_ERROR',
  PAYMENT_METHOD_NOT_SETUP = 'PAYMENT_METHOD_NOT_SETUP',
  RESUME_ERROR = 'RESUME_ERROR',
  TAX_ERROR = 'TAX_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
}

interface ErrorOptions {
  message: string;
  diagnosticsId?: string;
  errorId?: string;
  data?: any;
}

export class PrimerClientError extends Error {
  public code: ErrorCode;

  public message: string;

  public diagnosticsId: Nullable<string>;

  public data?: any;

  public static fromErrorCode(
    code: ErrorCode,
    options: ErrorOptions,
  ): PrimerClientError {
    return new PrimerClientError(code, options);
  }

  constructor(code: ErrorCode, options: ErrorOptions) {
    super(options.message);
    this.message = options.message;
    this.code = code;
    this.diagnosticsId = options.diagnosticsId || null;
    this.data = options.data;
  }
}
